import { createSpan, getRectangles } from './span'
import { createRelation } from './relation'
import { enableViewMode } from './view'

export default {
    createSpan,
    getRectangles,
    createRelation,
    enableViewMode
}



//////////////////
// WEBPACK FOOTER
// ./src/core/src/UI/index.js
// module id = 70
// module chunks = 1